<template>
	<div class="view-content-list">
		<ViewContentCard
			v-bind:contentModel="contentModel"
			v-bind:key="contentModel.id"
			v-for="contentModel in contentCollection.models"
			v-on:select="Handle_OnSelectContent"
		/>

		<ViewUiStateLoader v-if="contentCollection.length === 0" />
	</div>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Renders a vertical list of content cards from a collection.
	 * Handles empty/loading state and bubbles selection events.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Content
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewContentList extends ViewBase {
		/**
		 * Collection of content items to display
		 *
		 * @type ChalkySticks.Collection.Content
		 */
		@Prop({
			required: true,
		})
		public contentCollection!: ChalkySticks.Collection.Content;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Content contentModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectContent(contentModel: ChalkySticks.Model.Content): Promise<void> {
			this.$emit('content:select', contentModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-content-list {
		background: var(--chalky-blue-2);
		border-radius: 0.5rem;
		display: flex;
		flex-direction: column;
		gap: 1rem;
		margin-left: -0.25rem;
		margin-right: -0.25rem;
		padding: 0.75rem;
	}
</style>
